export const SPORT_DIVIDER_TEST_IDS = {
  /** Suffixed with the sport key, e.g. `create-sport-divider-BASKETBALL`. */
  rootPrefix: 'create-sport-divider-',
} as const;
